import { Badge } from '@/components/ui/badge';

interface ScheduleVisualizerProps {
  schedule: Record<string, string[][]>;
  compact?: boolean;
}

export function ScheduleVisualizer({ schedule, compact = false }: ScheduleVisualizerProps) {
  if (!schedule || Object.keys(schedule).length === 0) {
    return <Badge variant="secondary">24/7</Badge>;
  }

  const days = Object.keys(schedule);
  
  // Check for common patterns
  if (days.length === 7) {
    return <Badge>7 dagen/week</Badge>;
  }
  
  if (days.length === 5 && days.every(d => ['mon', 'tue', 'wed', 'thu', 'fri'].includes(d))) {
    const slots = schedule[days[0]];
    if (slots?.length === 1) {
      return <Badge>Ma-Vr {slots[0][0]}-{slots[0][1]}</Badge>;
    }
  }

  if (compact) {
    return <Badge variant="outline">Custom ({days.length}d)</Badge>;
  }

  // Full visualization
  const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  const LABELS = ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo'];

  return (
    <div className="flex gap-1">
      {WEEKDAYS.map((day, i) => (
        <div
          key={day}
          className={`w-6 h-6 rounded flex items-center justify-center text-xs ${
            schedule[day]?.length 
              ? 'bg-primary text-primary-foreground' 
              : 'bg-muted text-muted-foreground'
          }`}
          title={schedule[day] ? schedule[day].map(s => `${s[0]}-${s[1]}`).join(', ') : 'Niet actief'}
        >
          {LABELS[i]}
        </div>
      ))}
    </div>
  );
}
